import { render } from "./FoldableSectionCard.vue?vue&type=template&id=213b6c0a&scoped=true&ts=true"
import script from "./FoldableSectionCard.vue?vue&type=script&lang=ts"
export * from "./FoldableSectionCard.vue?vue&type=script&lang=ts"

import "./FoldableSectionCard.vue?vue&type=style&index=0&id=213b6c0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213b6c0a"]])

export default __exports__